module.exports = __webpack_public_path__ + "img/61.275cfb12.jpg";